import { Box, Flex, Heading, Text, Image } from "@chakra-ui/react";
import React, { useEffect } from "react";
import AOS from "aos";

export const About = () => {
  useEffect(() => {
    AOS.init({ delay: 300 });
  }, []);
  return (
    <>
      <Box
        b="none"
        textAlign={"center"}
        id="about"
        className="about section"
        color={"white"}
      >
        <Heading
          mt="50px"
          className="aboutmehead"
          display={"inline-block"}
          padding="10px"
          data-aos="fade-right"
          mb="45px"
          textAlign={"center"}
          size="2xl"
          as="h1"
        >
          About <span style={{ color: "#0ef", textAlign: "center" }}>Me</span>
        </Heading>
        <Flex
          justifyContent={"space-around"}
          direction={{
            base: "column",
            sm: "column",
            md: "column",
            lg: "row",
            xl: "row",
            "2xl": "row",
          }}
          gap="30px"
          alignItems={"center"}
        >
          <Box
            w={{
              base: "90%",
              sm: "90%",
              md: "70%",
              lg: "50%",
              xl: "40%",
              "2xl": "40%",
            }}
            data-aos="zoom-out"
          >
            <Image
              w="100%"
              border={"1px inset"}
              boxShadow="dark-md"
              p="6"
              rounded="md"
              src="https://img.freepik.com/free-photo/web-design-concept-with-drawings_1134-77.jpg?w=1060&t=st=1685370746~exp=1685371346~hmac=798fa5f314f08de3ed48799ae92da10f0aa89da9bb03b9e3ddf6236ae63fe4c"
              borderRadius={"10px"}
              alt="About_Image"
            />
          </Box>
          <Box
            w={{
              base: "90%",
              sm: "90%",
              md: "70%",
              lg: "50%",
              xl: "50%",
              "2xl": "50%",
            }}
          >
            <Text
              id="user-detail-intro"
              data-aos="fade-right"
              fontSize={{
                base: "16px",
                sm: "12px",
                md: "18px",
                lg: "18px",
                xl: "18px",
                "2xl": "20px",
              }}
              color={"white"}
              textAlign={"left"}
              mb="20px"
              fontWeight={"bold"}
            >
              Highly skilled full stack web developer proficient in MERN stack
              with a strong track record of building solo and collaborative
              projects. Adaptable and eager to embrace generative AI, showcasing
              the ability to swiftly learn new tech stacks. A valuable addition
              to any team, blending technical expertise with exceptional
              problem-solving and communication skills.
            </Text>{" "}
            <br />
            <Text
              id="user-detail-intro"
              data-aos="fade-right"
              fontSize={{
                base: "16px",
                sm: "12px",
                md: "18px",
                lg: "18px",
                xl: "18px",
                "2xl": "20px",
              }}
              color={"white"}
              textAlign={"left"}
              mb="20px"
              fontWeight={"bold"}
            >
              Now, I am enthusiastic about applying my talents in a Full Stack
              Web Developer role, contributing to cutting-edge projects and
              creating user-friendly solutions. Let's collaborate to build
              exceptional web experiences and drive innovation in the digital
              realm.
            </Text>
          </Box>
        </Flex>
      </Box>
    </>
  );
};
